'use client'

import { Button as ResponsiveButton } from 'antd'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
config.autoAddCss = false
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

interface ButtonProps {
  dataTestId?: string
  text: string | React.ReactNode
  type?: 'default' | 'primary' | 'dashed' | 'link' | 'text'
  icon?: IconProp
  onClick?: () => void
  isActive?: boolean
  ariaLabel?: string
  danger?: boolean
  loading?: boolean
  disabled?: boolean
  ariaBusy?: boolean
  block?: boolean
  className?: string
  size?: 'small' | 'middle' | 'large'
  href?: string

  color?: 'primary' | 'default'
  variant?: 'outlined' | 'solid' | 'filled'
  rel?: string
  target?: string
}

export const Button = ({
  dataTestId,
  text,
  type,
  icon,
  onClick,
  isActive,
  ariaLabel,
  danger,
  block,
  loading,
  disabled,
  ariaBusy,
  className,
  size,
  href,
  color,
  variant,
  rel,
  target,
}: ButtonProps) => {
  return (
    <ResponsiveButton
      data-testid={dataTestId}
      type={type || 'default'}
      icon={icon && <FontAwesomeIcon icon={icon} className={'mr-2'} />}
      onClick={onClick}
      aria-pressed={isActive}
      aria-label={ariaLabel}
      danger={danger}
      loading={loading}
      block={block}
      disabled={disabled}
      aria-busy={ariaBusy}
      className={className}
      size={size}
      href={href}
      color={color}
      variant={variant}
      rel={rel}
      target={target}
      style={{
        boxShadow: variant === 'outlined' ? 'none' : '',
      }}
    >
      {text}
    </ResponsiveButton>
  )
}
